import {createTheme, Palette} from "@mui/material/styles";
import {boxStyles} from "../boxStyles";

declare module "@mui/material/styles" {
  interface PaletteColor {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    A100: string;
    A200: string;
    A400: string;
    A700: string;
  }

  interface Palette {
    primary: PaletteColor;
    secondary: PaletteColor;
    custom: {
      blue: string;
      purple: string;
    };
    component: PaletteColor;
    common: {
      white: string;
      black: string;
    };
    text: {
      primary: string;
      secondary: string;
      disabled: string;
    };
  }
}

const theme = createTheme({

  typography: {
    fontFamily: "Inter, sans-serif, Arial",
    h1: {
      "@media print": {
        fontSize: "8rem",
        borderBottom: "20px solid red",
        color: "blue"
      }
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
        },
        p: {
          wordBreak: "break-word",
        },
        ".tooltip-arrow": {
          border: "1px solid #FFB9C0",
        },
        ...boxStyles(),
      },
    },
  },
  palette: {
    primary: {
      main: "#6E6E6E",
      light: "#C5C5C5",
      dark: "#363636",
      contrastText: "#000000",
      50: "#C5C5C5",
      100: "#BFBFBF",
      200: "#BABABA",
      300: "#ACACAC",
      400: "#8A8A8A",
      500: "#6E6E6E",
      600: "#484848",
      700: "#363636",
      800: "#1A1A1A",
      900: "#000000",
    },
    secondary: {
      main: "#FF1D02",
      dark: "#C10000",
      light: "#FFB9C0",
      contrastText: "#182FFE",
      50: "#FFD8E0",
      100: "#FFB9C0",
      200: "#FF847F",
      300: "#F95B58",
      400: "#FF352E",
      500: "#FF1D02",
      600: "#F40009",
      700: "#DE0005",
      800: "#D10000",
      900: "#C10000",
      A100: "#FF7760",
      A200: "#FF2C2F",
      A400: "#FF0025",
      A700: "#DD0000",
    },
    custom: {
      blue: "#1130DF",
      purple: "#7B1FA2",
    },
    component: {
      main: "#A3A3A3",
      50: "#FFFFFF",
      100: "#F9F9F9",
      200: "#F3F3F3",
      300: "#E5E5E5",
      400: "#C1C1C1",
      500: "#A3A3A3",
      600: "#797979",
      700: "#666666",
      800: "#474747",
      900: "#262626",
    },
    common: {
      white: "#FFFFFF",
      black: "#262626",
    },
    text: {
      primary: "#000000",
      secondary: "#262626",
      disabled: "#CCCCCC",
    },
  } as Palette,
});

export default theme;
